import * as React from "react";

import { Attachment, UploadAttachment } from "../utils/ServiceManagerAPI";

import SkeletonWrapper from "./SkeltonWrapper";
import "../main.css";

const AttachmentUpload = ({ questionId, questionnaireId, done }: { questionId: string; questionnaireId: string; done?: Function }) => {
    const [id, setId] = React.useState(Math.floor(Math.random() * 100000).toString());
    const [loading, setLoading] = React.useState(false);

    const handleContentChange = (e) => {
        for (let i = 0; i < e.target.files.length; i++) {
            let content = e.target.files[i];

            if (content) {
                setLoading(true);
                var reader = new FileReader();
                reader.readAsDataURL(content);
                reader.onload = (evt: any) => {
                    UploadAttachment({
                        content: evt.target.result.replace(/^data:(\w+|\-|\/|\.)+;base64,/, ""),
                        contentType: content.type,
                        name: content.name,
                        questionID: questionId,
                        questionnaireID: questionnaireId,
                    } as Attachment).then((res) => {
                        done && done(res);
                        setLoading(false);
                    });
                };
            }
        }
    };

    return (
        <div>
            <input 
                type="file" 
                disabled={loading} 
                id={id} 
                onChange={handleContentChange} 
                multiple 
                className="block w-full text-sm text-gray-900 dark:text-gray-100 file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:text-sm file:font-semibold file:bg-brand file:text-white hover:file:bg-brand-dark disabled:opacity-50"
            />
            <SkeletonWrapper loading={loading}>
                <></>
            </SkeletonWrapper>
        </div>
    );
};
export default AttachmentUpload;
